import './src/styles/main.scss';